
import request from "@/utils/request";

export function getAllFruitOffTypeOptions() {
    return request({
        url: "/api/services/app/FruitOffType/GetAllForDropdown",
        method: "GET"
    });
}

export function fruitOffTypeAllFromCrossType(params) {
    return request({
        url: "/api/services/app/FruitOffType/GetAllFruitTypeFromCrossType",
        method: "GET",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/fruit_off_type.js